import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfilePaymethodsPage } from './profile-paymethods.page';

const routes: Routes = [
    {
        path: '',
        component: ProfilePaymethodsPage,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProfilePaymethodsPageRoutingModule {}
